import Api from '@api';

import clientCommon from './blocks/common'
import clientTag from './blocks/tag'

import { formConfig } from './config/formConfig'

export default {
  name: 'preAdviceHeadDetail',
  components: {
    clientCommon,
    clientTag
  },
  data() {
    return {
      current:'',
      clientCommonData: {
        _current: '',
      },
    };
  },
  activated() {
    this.$nextTick(()=>{
      this.init();
    })
  },
  mounted() {
    this.$nextTick(()=>{
      this.init();
    })
  },
  computed:{
    injectData(){
      return this.$route.query || {_current:''}
    }
  },
  methods: {
    init(){
      this.getOrderHeaderData();
    },

    async getOrderHeaderData() {
      this.setCurrent('head')
      if(!this.injectData.PRE_ADVICE_ID) return ;
      let { status, data } = await Api.GetPreadviceHeaderInfo({CLIENT_ID: this.injectData.CLIENT_ID,PRE_ADVICE_ID: this.injectData.PRE_ADVICE_ID});
      if (Number(status) === 200) {

        let result = data;
        this.$refs.clientCommon.$refs.clientCommon.formData = result;

        formConfig(this).thead
          .filter(item => item !== "THead")
          .forEach(item => {
            this.$refs.clientTag.$refs[item][0].formData = result
          })
      }
    },
    /*
    * 设置当前查询的是行还是列
    * */
    setCurrent(name){
      this.clientCommonData._current = name
      this.current = name
    },
    toGetLineList(){
      this.$store.commit('SET_CURRENT_HEADERS',{model:'preAdvice',header:[this.injectData.PRE_ADVICE_ID]})
      this.$store.commit('SET_CURRENT_TAB',{model:'preAdvice',currentTab:'lineCom'})
      this.$router.push('/preAdvice')
    },
    handleConfirm() {},
    handleClose() {
      this.$emit('close')
    }
  }
}